import { useEffect, useState } from "react";
import { Copy } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

export const IntegrationsTab = () => {
  const [info, setInfo] = useState(null);

  useEffect(() => {
    api.get("/admin/integrations").then((r) => setInfo(r.data)).catch(() => {});
  }, []);

  if (!info) return <p className="text-zinc-400 text-sm py-12">Loading integration details…</p>;

  const copy = (text, label) => {
    navigator.clipboard.writeText(text).then(() => toast.success(`${label} copied`));
  };

  return (
    <div className="max-w-4xl space-y-10" data-testid="integrations-tab">
      <div>
        <p className="font-serif text-2xl text-zinc-900">Order Aggregator API</p>
        <p className="text-sm text-zinc-500 mt-2 leading-relaxed">
          Connect EasyEcom or any order aggregator to pull orders into your centralised workflow and push
          courier/tracking updates back. Customers are emailed automatically on every status change.
        </p>
      </div>
      <div className="border border-zinc-200 p-6">
        <p className="text-[10px] uppercase tracking-[0.3em] text-zinc-400 mb-3">API Key (send as X-API-Key header)</p>
        <div className="flex items-center gap-3">
          <code className="flex-1 bg-zinc-100 border border-zinc-200 px-4 py-3 text-sm text-zinc-800 font-mono break-all" data-testid="integrations-api-key">
            {info.api_key}
          </code>
          <button onClick={() => copy(info.api_key, "API key")} data-testid="integrations-copy-key" className="p-3 border border-zinc-200 text-zinc-500 hover:text-gold hover:border-gold transition-colors duration-200" aria-label="Copy key">
            <Copy size={15} />
          </button>
        </div>
      </div>
      <div className="border border-zinc-200 p-6">
        <p className="text-[10px] uppercase tracking-[0.3em] text-zinc-400 mb-4">Endpoints</p>
        <div className="space-y-4">
          {info.endpoints.map((e, i) => (
            <div key={i} className="flex flex-wrap items-baseline gap-3">
              <span className={`text-[10px] font-bold uppercase tracking-wider px-2 py-1 ${e.method === "GET" ? "bg-emerald-50 text-emerald-600" : "bg-amber-50 text-amber-600"}`}>{e.method}</span>
              <code className="text-sm text-zinc-800 font-mono">{e.path}</code>
              <span className="text-xs text-zinc-400">{e.description}</span>
            </div>
          ))}
        </div>
        <div className="mt-6 bg-zinc-50 border border-zinc-100 p-5">
          <p className="text-[10px] uppercase tracking-[0.3em] text-zinc-400 mb-3">Sample — pull orders</p>
          <code className="text-xs text-zinc-600 font-mono break-all" data-testid="integrations-sample">
            curl -H "X-API-Key: {info.api_key}" "{info.base_url}/integrations/orders"
          </code>
        </div>
        <p className="text-xs text-zinc-400 mt-4 leading-relaxed">
          Push updates with PUT /api/integrations/orders/{"{order_id}"} and a body of status, courier_partner,
          tracking_id, tracking_url. Statuses: confirmed, packed, shipped, out_for_delivery, delivered, cancelled.
        </p>
      </div>
    </div>
  );
};
